import { useEffect } from "react";
import classes from "./AboutUsEB.module.css";
import Aos from "aos";
import "aos/dist/aos.css";

//26.27
let Olakunle = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786397720/eniola-jukebox-bg-removed_t9y8ar.png';
let Olaoye = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786397006/AtiradeoluwaOlaoye_t0yxd1.png'
let Adeola = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786397003/AdeolaAdedara_fcewxl.png'
let Sabatha = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786397016/SabathaJoshua_z32cul.png'
let Demilade = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786396999/DemiladeAdekunle_s19puf.png'
let Favour = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786396999/FavourBassey_ttdzrd.png'
let Toluwalase = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786397452/Toluwalase_Oluwadamilola_Agbetuyi_-jukebox-bg-removed_f4hthw.png'
let Israel = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1786397011/AjayiIsrael_zdcip0.png'

// 25.26
// let Olakunle = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1764705232/eniola_2_n7uxsd.png';
// let Adedayo = 'https://res.cloudinary.com/dof4l5eul/image/upload/v1732892465/AIESEC/Oseni_Adedayo_MCVP_F_L_bfhpny.jpg';
// let Michael = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1764794777/Michael_Shekinah_1_fpotcy.jpg';
// let Egwim =  'https://res.cloudinary.com/dumoghqlq/image/upload/v1764541569/egwim_theresa-min_kgfh6i.png';
// let Ebube = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1764540398/purp_wom_zmyrx1.png';
// let Ndive = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1764541010/ndive_chisom_dcxtaa.png';
// let Kareem = 'https://res.cloudinary.com/dumoghqlq/image/upload/v1764795136/ks_2_lyex3w.png';
// let Iyanda = "https://res.cloudinary.com/dumoghqlq/image/upload/v1777904987/yemisi4_jqpcro.png";



const AboutUsEB = () => {
  const executiveBoard = [
    {
      name: "Olakunle Eniola",
      role: "Country Director",
      image: Olakunle,
    },
    {
      name: "Adeola Adedara",
      role: "Finance Manager",
      image: Adeola,
    },
    {
      name: "Toluwalase Agbetuyi",
      role: "Programs Manager",
      image: Toluwalase,
    },
    {
      name: "Ajayi Israel",
      role: "Product Operations Manager",
      image: Israel,
    }, 
    {
      name: "Demilade Adekunle",
      role: "Marketing Manager",
      image: Demilade,
    },
    {
      name: "Sabatha Joshua",
      role: "Expansion and PR Manager",
      image: Sabatha,
    },
    {
      name: "Atiradeoluwa Olaoye",
      role: "Partnerships Manager",
      image: Olaoye,
    },
    {
      name: "Favour Bassey",
      role: "Human Resource Manager",
      image: Favour,
    },
   
  ];

  // Effects
useEffect(() => {
  Aos.init({ duration: 1000 });
}, []);

  return (
    <section className={classes.container}>
      <div className={classes.header} data-aos="fade-up">
        We are led by the{" "}
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="11"
            viewBox="0 0 162 11"
            fill="none"
          >
            <path
              d="M1 10C37.7712 10 74.2887 3.09566 111.21 2.83709C126.523 2.72985 141.695 2.64292 156.984 2.83709C161.126 2.88969 160.943 2.11566 156.798 2.04119C149.442 1.90899 142.68 0.703723 135.165 1.06845C121.289 1.74189 107.367 1.2599 93.4762 1.86433C65.1485 3.09692 36.7924 2.63568 8.52067 3.63296"
              stroke="#037EF3"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <span>right people</span>
        </span>{" "}
        with the right skills
      </div>
      <div className={classes.ebInfoSection}>
        {executiveBoard.map((data, i) => {
          return (
            <div key={i} className={classes.ebPerson} data-aos="fade-up">
              <img src={data.image} alt={data.name} loading="lazy" onLoad={() => Aos.refresh()}/>
              <div>
                <h6>{data.role}</h6>
                <p>{data.name}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AboutUsEB;
